// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LeftPanel_leftPanel__iXDFL {
  flex: 1 1;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  /* ✅ UX: enable smooth width transition when collapsing / expanding */
  position: relative;
  transition: width 0.25s ease, padding 0.25s ease, flex-basis 0.25s ease;
  box-sizing: border-box;
}

/* ============================================================
   ✅ UX: COLLAPSED RAIL
   When the panel is collapsed, shrink to a thin strip showing
   only the toggle button. The parent flex layout (in
   PreviewTester.module.css) handles the push / pull.
   ============================================================ */
.LeftPanel_leftPanelCollapsed__jRvTI {
  width: 40px;
  min-width: 40px;
  max-width: 40px;
  padding: 0;
  overflow: hidden;
  flex: 0 0 40px;
}

/* ============================================================
   ✅ UX: TOGGLE BUTTON
   Pinned to the top-right of the panel. When collapsed, the
   arrow flips to point right (▶); when expanded, it points
   left (◀).
   ============================================================ */
.LeftPanel_leftPanelToggle__Bb4ps {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 20;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: white;
  color: #4a5568;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: background-color 0.15s ease, color 0.15s ease,
    border-color 0.15s ease, transform 0.15s ease;
  padding: 0;
  line-height: 1;
  font-family: inherit;
}

.LeftPanel_leftPanelToggle__Bb4ps:hover {
  background: #f7fafc;
  color: #2b6cb0;
  border-color: #bee3f8;
}

.LeftPanel_leftPanelToggle__Bb4ps:active {
  transform: scale(0.95);
}

/* When collapsed, center the toggle horizontally on the rail */
.LeftPanel_leftPanelCollapsed__jRvTI .LeftPanel_leftPanelToggle__Bb4ps {
  right: 6px;
  top: 12px;
}

.LeftPanel_inputGroup__3xDTj {
  margin-bottom: 20px;
}

.LeftPanel_label__Ryc1s {
  display: block;
  font-weight: 500;
  color: #2d3748;
  margin-bottom: 8px;
}

.LeftPanel_textarea__iCjRh {
  width: 100%;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 14px;
  font-family: monospace;
  background-color: #f7fafc;
  margin-top: 4px;
  resize: vertical;
  box-sizing: border-box;
}

.LeftPanel_textarea__iCjRh:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
}

.LeftPanel_fieldHelpers__BIlA6 {
  margin: 8px 0;
}

.LeftPanel_helperText__Pl6P9 {
  font-size: 12px;
  color: #718096;
}

.LeftPanel_fieldButtons__2SrGB {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.LeftPanel_fieldButton__samV4 {
  padding: 4px 10px;
  background-color: #ebf8ff;
  border: 1px solid #bee3f8;
  border-radius: 4px;
  font-size: 12px;
  color: #2b6cb0;
  cursor: pointer;
  transition: all 0.2s;
}

.LeftPanel_fieldButton__samV4:hover {
  background-color: #bee3f8;
  transform: translateY(-1px);
}

.LeftPanel_fieldButton__samV4:active {
  transform: translateY(0);
}

.LeftPanel_errorMessage__PJG0s {
  padding: 12px;
  background-color: #fed7d7;
  color: #c53030;
  border-radius: 4px;
  margin-top: 10px;
  border: 1px solid #feb2b2;
}

.LeftPanel_renderButton__SxwjC {
  width: 100%;
  padding: 12px;
  background-color: #4299e1;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 10px;
}

.LeftPanel_renderButton__SxwjC:hover:not(:disabled) {
  background-color: #3182ce;
}

.LeftPanel_renderButton__SxwjC:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.LeftPanel_sampleInfo__a6nOF {
  margin-top: 20px;
  padding: 12px;
  background-color: #f7fafc;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.LeftPanel_subtitle__-W37C {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.LeftPanel_sampleData__02IZ- {
  font-size: 12px;
  font-family: monospace;
  color: #4a5568;
  overflow: auto;
  max-height: 200px;
  white-space: pre-wrap;
  word-break: break-word;
}

/* ============================================================
   VALIDATION STYLES - for validation messages
   ============================================================ */

.LeftPanel_validationErrors__Op1MP {
  background-color: #fed7d7;
  border: 1px solid #fc8181;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
}

.LeftPanel_validationWarnings__HzLek {
  background-color: #fefcbf;
  border: 1px solid #f6ad55;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
}

/* ============================================================
   RESET CONFIRMATION MODAL
   ============================================================ */

.LeftPanel_resetOverlay__2GThe {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(4px);
  animation: LeftPanel_fadeIn__XCKWO 0.3s ease;
}

@keyframes LeftPanel_fadeIn__XCKWO {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes LeftPanel_pulseWarning__LwVks {
  0% {
    box-shadow: 0 0 0 0 rgba(237, 137, 54, 0.4);
  }
  70% {
    box-shadow: 0 0 0 15px rgba(237, 137, 54, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(237, 137, 54, 0);
  }
}

.LeftPanel_resetModal__joHFA {
  background-color: white;
  border-radius: 16px;
  padding: 32px 40px;
  max-width: 480px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  position: relative;
}

/* ============================================================
   SCROLLBAR STYLES
   ============================================================ */

.LeftPanel_leftPanel__iXDFL::-webkit-scrollbar {
  width: 6px;
}

.LeftPanel_leftPanel__iXDFL::-webkit-scrollbar-track {
  background: #f7fafc;
}

.LeftPanel_leftPanel__iXDFL::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 3px;
}

.LeftPanel_leftPanel__iXDFL::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

/* ============================================================
   RESPONSIVE
   ============================================================ */

@media (max-width: 768px) {
  .LeftPanel_leftPanel__iXDFL {
    padding: 12px;
  }

  .LeftPanel_fieldButtons__2SrGB {
    gap: 2px;
  }

  .LeftPanel_fieldButton__samV4 {
    font-size: 11px;
    padding: 3px 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/PreviewTesterHome/PreviewTester/components/LeftPanel.module.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,qEAAqE;EACrE,kBAAkB;EAClB,uEAAuE;EACvE,sBAAsB;AACxB;;AAEA;;;;;iEAKiE;AACjE;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;iEAKiE;AACjE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC;iDAC+C;EAC/C,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;iEAEiE;;AAEjE;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,4CAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;;iEAEiE;;AAEjE;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".leftPanel {\n  flex: 1;\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow-y: auto;\n  /* ✅ UX: enable smooth width transition when collapsing / expanding */\n  position: relative;\n  transition: width 0.25s ease, padding 0.25s ease, flex-basis 0.25s ease;\n  box-sizing: border-box;\n}\n\n/* ============================================================\n   ✅ UX: COLLAPSED RAIL\n   When the panel is collapsed, shrink to a thin strip showing\n   only the toggle button. The parent flex layout (in\n   PreviewTester.module.css) handles the push / pull.\n   ============================================================ */\n.leftPanelCollapsed {\n  width: 40px;\n  min-width: 40px;\n  max-width: 40px;\n  padding: 0;\n  overflow: hidden;\n  flex: 0 0 40px;\n}\n\n/* ============================================================\n   ✅ UX: TOGGLE BUTTON\n   Pinned to the top-right of the panel. When collapsed, the\n   arrow flips to point right (▶); when expanded, it points\n   left (◀).\n   ============================================================ */\n.leftPanelToggle {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 20;\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: white;\n  color: #4a5568;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  transition: background-color 0.15s ease, color 0.15s ease,\n    border-color 0.15s ease, transform 0.15s ease;\n  padding: 0;\n  line-height: 1;\n  font-family: inherit;\n}\n\n.leftPanelToggle:hover {\n  background: #f7fafc;\n  color: #2b6cb0;\n  border-color: #bee3f8;\n}\n\n.leftPanelToggle:active {\n  transform: scale(0.95);\n}\n\n/* When collapsed, center the toggle horizontally on the rail */\n.leftPanelCollapsed .leftPanelToggle {\n  right: 6px;\n  top: 12px;\n}\n\n.inputGroup {\n  margin-bottom: 20px;\n}\n\n.label {\n  display: block;\n  font-weight: 500;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: monospace;\n  background-color: #f7fafc;\n  margin-top: 4px;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n.textarea:focus {\n  outline: none;\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);\n}\n\n.fieldHelpers {\n  margin: 8px 0;\n}\n\n.helperText {\n  font-size: 12px;\n  color: #718096;\n}\n\n.fieldButtons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.fieldButton {\n  padding: 4px 10px;\n  background-color: #ebf8ff;\n  border: 1px solid #bee3f8;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #2b6cb0;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.fieldButton:hover {\n  background-color: #bee3f8;\n  transform: translateY(-1px);\n}\n\n.fieldButton:active {\n  transform: translateY(0);\n}\n\n.errorMessage {\n  padding: 12px;\n  background-color: #fed7d7;\n  color: #c53030;\n  border-radius: 4px;\n  margin-top: 10px;\n  border: 1px solid #feb2b2;\n}\n\n.renderButton {\n  width: 100%;\n  padding: 12px;\n  background-color: #4299e1;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-top: 10px;\n}\n\n.renderButton:hover:not(:disabled) {\n  background-color: #3182ce;\n}\n\n.renderButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.sampleInfo {\n  margin-top: 20px;\n  padding: 12px;\n  background-color: #f7fafc;\n  border-radius: 4px;\n  border: 1px solid #e2e8f0;\n}\n\n.subtitle {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.sampleData {\n  font-size: 12px;\n  font-family: monospace;\n  color: #4a5568;\n  overflow: auto;\n  max-height: 200px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* ============================================================\n   VALIDATION STYLES - for validation messages\n   ============================================================ */\n\n.validationErrors {\n  background-color: #fed7d7;\n  border: 1px solid #fc8181;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.validationWarnings {\n  background-color: #fefcbf;\n  border: 1px solid #f6ad55;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n}\n\n/* ============================================================\n   RESET CONFIRMATION MODAL\n   ============================================================ */\n\n.resetOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(4px);\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes pulseWarning {\n  0% {\n    box-shadow: 0 0 0 0 rgba(237, 137, 54, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 15px rgba(237, 137, 54, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(237, 137, 54, 0);\n  }\n}\n\n.resetModal {\n  background-color: white;\n  border-radius: 16px;\n  padding: 32px 40px;\n  max-width: 480px;\n  width: 90%;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  position: relative;\n}\n\n/* ============================================================\n   SCROLLBAR STYLES\n   ============================================================ */\n\n.leftPanel::-webkit-scrollbar {\n  width: 6px;\n}\n\n.leftPanel::-webkit-scrollbar-track {\n  background: #f7fafc;\n}\n\n.leftPanel::-webkit-scrollbar-thumb {\n  background: #cbd5e0;\n  border-radius: 3px;\n}\n\n.leftPanel::-webkit-scrollbar-thumb:hover {\n  background: #a0aec0;\n}\n\n/* ============================================================\n   RESPONSIVE\n   ============================================================ */\n\n@media (max-width: 768px) {\n  .leftPanel {\n    padding: 12px;\n  }\n\n  .fieldButtons {\n    gap: 2px;\n  }\n\n  .fieldButton {\n    font-size: 11px;\n    padding: 3px 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"leftPanel": `LeftPanel_leftPanel__iXDFL`,
	"leftPanelCollapsed": `LeftPanel_leftPanelCollapsed__jRvTI`,
	"leftPanelToggle": `LeftPanel_leftPanelToggle__Bb4ps`,
	"inputGroup": `LeftPanel_inputGroup__3xDTj`,
	"label": `LeftPanel_label__Ryc1s`,
	"textarea": `LeftPanel_textarea__iCjRh`,
	"fieldHelpers": `LeftPanel_fieldHelpers__BIlA6`,
	"helperText": `LeftPanel_helperText__Pl6P9`,
	"fieldButtons": `LeftPanel_fieldButtons__2SrGB`,
	"fieldButton": `LeftPanel_fieldButton__samV4`,
	"errorMessage": `LeftPanel_errorMessage__PJG0s`,
	"renderButton": `LeftPanel_renderButton__SxwjC`,
	"sampleInfo": `LeftPanel_sampleInfo__a6nOF`,
	"subtitle": `LeftPanel_subtitle__-W37C`,
	"sampleData": `LeftPanel_sampleData__02IZ-`,
	"validationErrors": `LeftPanel_validationErrors__Op1MP`,
	"validationWarnings": `LeftPanel_validationWarnings__HzLek`,
	"resetOverlay": `LeftPanel_resetOverlay__2GThe`,
	"fadeIn": `LeftPanel_fadeIn__XCKWO`,
	"resetModal": `LeftPanel_resetModal__joHFA`,
	"pulseWarning": `LeftPanel_pulseWarning__LwVks`
};
export default ___CSS_LOADER_EXPORT___;
